import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

import { PriceRangeInput } from '__generated__/api';

export const getPriceRangeInput = (searchCriteria: SearchCriteriaModel): PriceRangeInput | null => {
  if (searchCriteria.price && searchCriteria.price.length) {
    const [min, max] = searchCriteria.price.map(x => Number.parseInt(x, 10));

    if ((min || min === 0) && (max || max === 0)) {
      return {
        min,
        max
      };
    }
  }

  return null;
};
